import CTLUnReadCell from "application/components/CTLUnReadCell";
import AuthenticationService from "application/modules/authentication/AuthenticationService";
import { getCallCenterConfigurationReports } from "application/modules/configuration/callCenterConfiguration/component/allCallcenterRepots/reportMenu";
import { agentReportMoreVert } from "globals/configuration/agentReportMoreVert";
import { operatorUserMenus } from "globals/configuration/queryBaseReports/operatorUserMenus";

const callCenterConfigurationReports = getCallCenterConfigurationReports();
const buildModes = (agent) => {
  let source;
  if (AuthenticationService.isOperatorAdminOnlyUser()) {
    source = operatorUserMenus;
  } else if (agent) {
    source = agentReportMoreVert;
  } else {
    source = callCenterConfigurationReports;
  }
  return source.map((item) => ({
    id: item.key,
    name: item.name,
    iconName: item.icon,
    url: item.url,
    description: item.description,
  }));
};
const getAttributesByRole = (agent) => {
  return {
    enableAddButton: false,
    enableUpdateTableRecords: agent ? false : true,
    enableDownloadButton: true,
    enableAdvanceSearch: true,
    enableDownloadPdf: agent ? false : true,
    enableRefresh: true,
    enableExitButton: agent ? true : false,
    modes: buildModes(agent),
  };
};
const operationURLS = {
  list: "/agentPerformanceSummary/customerDailyPerformanceSummaryReportList",
  pdfDownload:
    "/agentPerformanceSummary/customerDailyPerformanceSummaryReportPDF",
  csvDownload:
    "/agentPerformanceSummary/customerDailyPerformanceSummaryReportCSV",
};

const getColumns = () => {
  return [
    {
      Header: "Start Date",
      accessor: "stDate",
      displayInList: true,
      allowInForm: false,
      allowFilter: true,
      dataType: "date",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    // {
    //   Header: "Queue",
    //   accessor: "queue",
    //   displayInList: true,
    //   allowInForm: false,
    //   allowFilter: false,
    //   dataType: "string",
    //   Cell: ({ value }) => <CTLUnReadCell value={value} />,
    // },
    // {
    //   Header: "Queue Name",
    //   accessor: "queueName",
    //   displayInList: true,
    //   allowInForm: false,
    //   allowFilter: false,
    //   dataType: "string",
    //   Cell: ({ value }) => <CTLUnReadCell value={value} />,
    // },
    {
      Header: "ABD at Queue",
      accessor: "abdAtQueue",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Agent/Queue",
      accessor: "agentFullName",
      displayInList: true,
      allowInForm: false,
      allowFilter: true,
      dataType: "string",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Answered By Name",
      accessor: "answeredByName",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Offered",
      accessor: "inOffered",
      displayInList: true,
      allowInForm: false,
      allowFilter: true,
      dataType: "string",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "In Answered",
      accessor: "inAns",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "In No Answered",
      accessor: "inNoAns",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "In Talk Time",
      accessor: "inTalkTime",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Dial Out",
      accessor: "outOffered",
      displayInList: true,
      allowInForm: false,
      allowFilter: true,
      dataType: "string",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Out Answered",
      accessor: "outAns",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Out No Answered",
      accessor: "outNoAns",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Out Talk Time",
      accessor: "outTalkTime",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Total Answered",
      accessor: "totalAns",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Total No Answered",
      accessor: "totalNoAns",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    // {
    //   Header: "Total Ring Time",
    //   accessor: "totalRingDuration",
    //   displayInList: true,
    //   allowInForm: true,
    //   allowFilter: false,
    //   dataType: "integer",
    //   allowReportColumn: true,
    //   Cell: ({ value }) => <CTLUnReadCell value={value} />,
    // },
    {
      Header: "Total Talk Time",
      accessor: "totalTalkTime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Average Talk Time",
      accessor: "avgTalkTime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Total Idle Time",
      accessor: "idealTime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Total Break Time",
      accessor: "totalBreakDuration",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Net Login Time",
      accessor: "netLoginTime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "ACW Time",
      accessor: "acwTime",
      displayInList: true,
      allowInForm: false,
      allowFilter: true,
      dataType: "string",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Total Login Time",
      accessor: "totalLoginDuration",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Total Unservice Time",
      accessor: "unserviceDuration",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      allowReportColumn: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    // ,
    // {
    //   Header: "Within 10 Sec",
    //   accessor: "second10",
    //   displayInList: true,
    //   allowInForm: true,
    //   allowFilter: false,
    //   dataType: "integer",
    //   allowReportColumn: true,
    //   Cell: ({ value }) => <CTLUnReadCell value={value} />,
    // },
    // {
    //   Header: "Within 20 Sec",
    //   accessor: "second20",
    //   displayInList: true,
    //   allowInForm: true,
    //   allowFilter: false,
    //   dataType: "integer",
    //   allowReportColumn: true,
    //   Cell: ({ value }) => <CTLUnReadCell value={value} />,
    // },
    // {
    //   Header: "Within 30 Sec",
    //   accessor: "second30",
    //   displayInList: true,
    //   allowInForm: true,
    //   allowFilter: false,
    //   dataType: "integer",
    //   allowReportColumn: true,
    //   Cell: ({ value }) => <CTLUnReadCell value={value} />,
    // },
    // {
    //   Header: "Within 40 Sec",
    //   accessor: "second40",
    //   displayInList: true,
    //   allowInForm: true,
    //   allowFilter: false,
    //   dataType: "integer",
    //   allowReportColumn: true,
    //   Cell: ({ value }) => <CTLUnReadCell value={value} />,
    // },
    // {
    //   Header: "Within 50 Sec",
    //   accessor: "second50",
    //   displayInList: true,
    //   allowInForm: true,
    //   allowFilter: false,
    //   dataType: "integer",
    //   allowReportColumn: true,
    //   Cell: ({ value }) => <CTLUnReadCell value={value} />,
    // },
    // {
    //   Header: "Within 60 Sec",
    //   accessor: "second60",
    //   displayInList: true,
    //   allowInForm: true,
    //   allowFilter: false,
    //   dataType: "integer",
    //   allowReportColumn: true,
    //   Cell: ({ value }) => <CTLUnReadCell value={value} />,
    // }
  ];
};

export { getColumns, getAttributesByRole, operationURLS };
